export default __webpack_public_path__ + "static/eben2x-8d08523e18429ad1fa4d732c9b5efaba.png";